import { useNavigate } from 'react-router-dom'
import { PageContainer } from '../components/shared'
import { ContactCreateForm } from '../components/contacts/ContactCreateForm'

export function ContactCreatePage() {
  const navigate = useNavigate()

  return (
    <PageContainer title="Add contact">
      <ContactCreateForm
        context={{ kind: 'standalone' }}
        onDone={(contactId) => navigate('/dashboard/contacts/' + contactId)}
      />
    </PageContainer>
  )
}
